import { Button, LinkButton, UIHeading2, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './BestPlaceReportDescription.css';
import { REPORT_FEATURES } from './constants';

export interface IBestPlaceReportDescriptionProps {
  reportUrl: string;
  isBestPlaceCheckout: boolean;
  reportExampleUrl: string;
  providerInfo?: string;
  handleBuyReport: VoidFunction;
  handleExamineReportExample: VoidFunction;
  getReportPrices: VoidFunction;
}

export const BestPlaceReportDescription: React.FC<IBestPlaceReportDescriptionProps> = props => {
  const {
    reportUrl,
    providerInfo,
    reportExampleUrl,
    isBestPlaceCheckout,
    handleBuyReport,
    handleExamineReportExample,
    getReportPrices,
  } = props;

  React.useEffect(() => {
    getReportPrices();
  }, [getReportPrices]);

  const content = (() => {
    const numberOfItemsPerColumn = Math.ceil(REPORT_FEATURES.length / 2);

    const columns = REPORT_FEATURES.reduce(
      (acc: { columnA: React.JSX.Element[]; columnB: React.JSX.Element[] }, { Icon, text }, ind) => {
        const item = (
          <li className={styles['content-item']} key={ind}>
            <span className={styles['content-item-icon']}>{Icon}</span>
            <UIText1>{text}</UIText1>
          </li>
        );

        const isFirstColumnContent = ind + 1 <= numberOfItemsPerColumn;

        (isFirstColumnContent ? acc.columnA : acc.columnB).push(item);

        return acc;
      },
      { columnA: [], columnB: [] },
    );

    return (
      <ul className={styles['content']}>
        <div className={styles['content-column']}>{columns.columnA}</div>
        <div className={styles['content-column']}>{columns.columnB}</div>
      </ul>
    );
  })();

  const purchaseButton = isBestPlaceCheckout ? (
    <LinkButton theme="fill_primary" onClick={handleBuyReport} href={reportUrl} target="_blank">
      Купить отчёт у партнёра
    </LinkButton>
  ) : (
    <Button theme="fill_primary" onClick={handleBuyReport}>
      Купить отчёт у партнёра
    </Button>
  );

  return (
    <section className={styles['wrapper']}>
      <div className={styles['header']}>
        <span>
          <UIHeading2>Отчёт о привлекательности объекта</UIHeading2>
          <span className={cx(styles['header-description'])}>
            <UIText1>Узнайте, насколько помещение и район подходят для вашего бизнеса</UIText1>
          </span>
        </span>
      </div>
      <div className={styles['secondary-header']}>
        <UIHeading4>Что входит в отчёт</UIHeading4>
      </div>
      {content}
      <div className={cx(styles['footer'])}>
        <div className={cx(styles['footer-buttons'])}>
          {purchaseButton}
          <LinkButton
            theme="fill_white_primary"
            href={reportExampleUrl}
            download="report-example"
            target="_blank"
            rel="noreferrer"
            onClick={handleExamineReportExample}
          >
            Посмотреть пример отчёта
          </LinkButton>
        </div>
        {providerInfo && <UIText2 color="text-secondary-default">{providerInfo}</UIText2>}
      </div>
    </section>
  );
};

BestPlaceReportDescription.displayName = 'BestPlaceReportDescription';
